import {
  BOUNDARY_STUDY,
  EXPRESSION_STUDIES,
  type ExpressionStudy,
} from "./expression-studies";
import { EXPRESSION_STUDIO_WAVE_01 } from "./expression-study-wave-01";

/**
 * The runtime catalog is additive. The original 12-study foundation remains
 * byte-distinct in expression-studies.ts; expansion waves can be reviewed,
 * versioned, or withheld independently before promotion.
 */
export const ALL_EXPRESSION_STUDIES: ExpressionStudy[] = [
  BOUNDARY_STUDY,
  ...EXPRESSION_STUDIES,
  ...EXPRESSION_STUDIO_WAVE_01,
];

export const EXPRESSION_STUDY_BY_ID = new Map(
  ALL_EXPRESSION_STUDIES.map((study) => [study.id, study]),
);
